var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfLeather32 = function SvgHalfLeather32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9 25.5c-.99-.068-2 0-3 .5l-2-3.114c7.109-6.698 0-12.034 0-12.034L5.949 7.35C12.818 8.011 12.748 2 12.748 2h6.504c.023.88.362 2.2.748 3.001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.733 7a8.447 8.447 0 0 0 2.371.068L27 10.614s-6.916 5.398 0 12.184l-1.896 3.044s-6.53-1.758-9.777 4.158v-.002C14.76 28.938 13.95 28.244 13 27.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHalfLeather32;